import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SnackBarService } from './core';

@Injectable({
  providedIn: 'root',
})
export class VersionCheckService {
  // this will be replaced by actual hash post-build.js
  private currentHash = '{{POST_BUILD_ENTERS_HASH_HERE}}';

  constructor(private http: HttpClient,
              private snackBarService: SnackBarService) {
  }

  /**
   * Checks in every set frequency the version of frontend application
   */
  public initVersionCheck(url, frequency = 1000 * 60 * 5) {
    setInterval(() => {
      this.checkVersion(url);
    }, frequency);
  }

  /**
   * Will do the call and check if the hash has changed or not
   */
  private checkVersion(url) {
    // timestamp these requests to invalidate caches
    this.http.get(url + '?t=' + new Date().getTime()).subscribe(
      (response: any) => {
        if (response) {
          const hash = response.hash;
          const hashChanged = this.hasHashChanged(this.currentHash, hash);
          // If new version, do something
          if (hashChanged) {
            let duration = 10000; // Automatic refresh in  10s
            this.snackBarService.openWithConfig('New Release Available. Browser will get reloaded in 10s', 'info', 'Refresh Now',
              {
                duration: duration,
                horizontalPosition: 'center',
                verticalPosition: 'top',
                announcementMessage: 'New Version Available.'
              });
            setTimeout(() => {
              window.location.reload();
            }, duration);
          }
          // store the new hash so we wouldn't trigger versionChange again
          // only necessary in case you did not force refresh
          this.currentHash = hash;
        }
      },
      (err) => {
        console.error(err, 'Could not get version');
      }
    );
  }

  /**
   * Checks if hash has changed.
   * This file has the JS hash, if it is a different one than in the version.json
   * we are dealing with version change
   */
  private hasHashChanged(currentHash, newHash) {
    if (!currentHash || currentHash === '{{POST_BUILD_ENTERS_HASH_HERE}}') {
      return false;
    }

    return currentHash !== newHash;
  }
}
